import { createFileRoute } from "@tanstack/react-router";

import { DietBuilder } from "@/features/my-diet/modules/diet-builder/diet-builder";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/diet/$planId")({
  loader: () => ({ crumb: m.my_diet_edit() }),
  component: DietPlanPage,
});

function DietPlanPage() {
  const { planId } = Route.useParams();
  return <DietBuilder planId={planId} />;
}
